import styled from "styled-components";

export const Styledtd = styled.td`
  padding-left: 1rem;
  font-size: 1.2rem;
`;
